export default function isEmpty(array: any[]): boolean {
  return array.length === 0;
}
